import { render, staticRenderFns } from "./InputAddress.vue?vue&type=template&id=63e4d8d4&scoped=true"
import script from "./InputAddress.vue?vue&type=script&lang=js"
export * from "./InputAddress.vue?vue&type=script&lang=js"
import style0 from "./InputAddress.vue?vue&type=style&index=0&id=63e4d8d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e4d8d4",
  null
  
)

export default component.exports